// extracted by mini-css-extract-plugin
export default {"inner":"footer_inner__0kIau","list":"footer_list__vJHZB"};